/**
 * Makes sure a cart drawer opens after every successful add to cart.
 *
 * The Snap cart drawer app replaces the theme drawer and opens itself on add,
 * but only once its script has initialised. On slow connections a shopper can
 * tap "In den Warenkorb" before that, the item is added and nothing opens.
 * Adds also come from other apps (the AOV bundle offer posts to /cart/add.js
 * directly), so this watches the network rather than theme events.
 */
const ADD_URL = /\/cart\/add(\.js)?(\?|$)/;
// Long enough for the app to open its own drawer first, so we never fight it.
const GRACE_MS = 800;
const APP_READY_TIMEOUT_MS = 10000;
const STALE_MS = 15000;

let pendingCheck = 0;

function appDrawer() {
  return document.getElementById('wizz4-cart-drawer');
}

function isOpen() {
  const drawer = appDrawer();
  if (drawer) {
    const rect = drawer.getBoundingClientRect();
    return rect.width > 0 && rect.left < window.innerWidth - 1 && getComputedStyle(drawer).display !== 'none';
  }
  return !!document.querySelector('#cart-drawer dialog[open]');
}

function waitForApp() {
  return new Promise((resolve) => {
    const started = performance.now();
    const tick = () => {
      if (typeof window.openSnapCart === 'function' && window.__snapCartInitialized) return resolve(true);
      if (performance.now() - started > APP_READY_TIMEOUT_MS) return resolve(false);
      setTimeout(tick, 150);
    };
    tick();
  });
}

async function openDrawer() {
  if (isOpen()) return;

  // App present (embed markup or its globals): let it own the drawer.
  if (appDrawer() || 'openSnapCart' in window || '__snapCartPendingEvents' in window) {
    if (await waitForApp()) {
      if (isOpen()) return;
      window.refreshSnapCart?.();
      window.openSnapCart?.();
      return;
    }
  }

  // No app, or it never came up: fall back to the theme drawer.
  /** @type {any} */ (document.querySelector('theme-drawer#cart-drawer'))?.open?.();
}

/** @param {PerformanceResourceTiming} entry */
function handle(entry) {
  if (!ADD_URL.test(entry.name)) return;
  if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') return;
  // responseStatus is missing in Safari and Firefox; treat that as success.
  if (entry.responseStatus && entry.responseStatus >= 400) return;
  if (performance.now() - entry.responseEnd > STALE_MS) return;

  // Debounce: bundle offers fire several cart requests per click.
  clearTimeout(pendingCheck);
  let seenOpen = isOpen();
  const started = performance.now();
  const poll = () => {
    seenOpen ||= isOpen();
    if (seenOpen) return;
    if (performance.now() - started < GRACE_MS) {
      pendingCheck = window.setTimeout(poll, 100);
    } else {
      openDrawer();
    }
  };
  poll();
}

if ('PerformanceObserver' in window) {
  // buffered: catch adds that finished before this module ran.
  new PerformanceObserver((list) => list.getEntries().forEach((e) => handle(/** @type {any} */ (e)))).observe({
    type: 'resource',
    buffered: true,
  });
}
